(() => {
  const root = document.querySelector('[data-blog-filter-root]');
  if (!root) return;

  const buttons = [...root.querySelectorAll('[data-blog-filter]')];
  const cards = [...root.querySelectorAll('[data-blog-category]')];
  const status = root.querySelector('[data-blog-filter-status]');
  if (!buttons.length || !cards.length) return;

  const applyFilter = (filter) => {
    let visibleCount = 0;

    cards.forEach((card) => {
      const visible = filter === 'all' || card.dataset.blogCategory === filter;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    buttons.forEach((button) => {
      const active = button.dataset.blogFilter === filter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    if (status) {
      const template = visibleCount === 1 ? root.dataset.blogStatusOne : root.dataset.blogStatusOther;
      status.textContent = (template || '%count%').replace('%count%',String(visibleCount));
    }
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => applyFilter(button.dataset.blogFilter));
  });

  applyFilter('all');
})();
